import React,{Component} from 'react';
import SimpleReactValidator from 'simple-react-validator';
import templateId from '../../../libraries/lang-id';
import language from '../../../libraries/label-lang';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {history} from '../../../shared/configure-store';
import {connect} from 'react-redux';
import {RootActions} from '../../../shared/root-action';
import Logo from '../../../images/logo.png';
import {bindActionCreators} from 'redux';
import {toast, ToastContainer} from 'react-toastify';
import _ from 'lodash';
import Api from '../../../libraries/api';
import AuthHelper from '../../../libraries/auth-helper';
import Copyright from '../../presentational/copyright';
import Tooltip from "@material-ui/core/Tooltip";

require('dotenv').config();

SimpleReactValidator.addLocale('indo', templateId);

class Company extends Component {

    constructor(props) {

        super(props);

        let lang = AuthHelper.getLang();

        this.validator = new SimpleReactValidator(
            {
                locale: lang
            }
        );

        this.state = {
            loading: false,
            showPassword: false,
            showPasswordConfirm: false,

            errors: {},

            companyName: '',
            primaryAddress: '',
            primaryCity: '',
            primaryState: '',
            primaryPostalCode: '',
            contactName: '',
            contactPhoneOffice: '',
            contactPhoneCell: '',
            contactEmail: '',
            tocAgreement: false,
            accountManagerId: '',
            storeName: '',
            companyType: '',
            owner: '',
            image:'',
            image_name:''
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChecked = this.handleChecked.bind(this);
    }

    componentDidMount() {
        document.title = 'Fresh Factory - Register Perusahaan';

        let data = AuthHelper.getProfile();
        if(data.users) {
            this.setState({
                contactName: data.users.first_name+' '+data.users.last_name,
                contactPhoneCell: data.users.phone,
                contactEmail: data.users.email,
            })
        }

    }

    componentWillReceiveProps() {

        let lang = AuthHelper.getLang();

        this.validator = new SimpleReactValidator(
            {
                locale: lang
            }
        );
    }

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    // handle iamge company
    handleUpload = e => {

        let temp = _.get(e,'target.files[0]',false);

        this.setState({
            errors: {image:''},
        });

        if(temp){
            if(e.target.files[0].size > 999999){

                this.setState({
                    errors: {
                        image: 'This file is too big. Maximum size is 1MB.'
                    },
                });

            }else if(e.target.files[0].name.toLowerCase().search('.jpeg') === -1 &&
                e.target.files[0].name.toLowerCase().search('.jpg') === -1  &&
                e.target.files[0].name.toLowerCase().search('.png') === -1){

                this.setState({
                    errors: {
                        image: 'This file is invalid. Only accept .jpg, .jpeg and .png'
                    },
                });

            }else{

                this.setState({
                    image: URL.createObjectURL(e.target.files[0]),
                    image_file: e.target.files[0],
                    image_name: e.target.files[0].name,
                });

            }
        }
    };


    handleSubmit = e => {

        e.preventDefault();

        if (!this.validator.allValid()) {

            this.setState({
                    errors: this.validator.getErrorMessages()
                }
            );

            return false;

        }

        if (!this.state.tocAgreement) {

            this.setState({
                    errors: {
                        tocAgreement: 'Cek untuk syarat dan ketentuan'
                    }
                }
            );

            return false;

        }

        this.setState({
                errors: {},
                loading: true,
            }
        );

        // let params = {
        //     companyName: this.state.companyName,
        //     primaryAddress: this.state.primaryAddress,
        //     primaryCity: this.state.primaryCity,
        //     primaryState: this.state.primaryState,
        //     primaryPostalCode: this.state.primaryPostalCode,
        //     contactName: this.state.contactName,
        //     contactPhoneOffice: this.state.contactPhoneOffice,
        //     contactPhoneCell: this.state.contactPhoneCell,
        //     contactEmail: this.state.contactEmail,
        //     tocAgreement: this.state.tocAgreement,
        //     image: this.state.image,
        // };
        let formData = new FormData();
        formData.append('companyName', this.state.companyName);
        formData.append('primaryAddress', this.state.primaryAddress);
        formData.append('primaryCity', this.state.primaryCity);
        formData.append('primaryState', this.state.primaryState);
        formData.append('primaryPostalCode', this.state.primaryPostalCode);
        formData.append('contactName', this.state.contactName);
        formData.append('contactPhoneOffice', this.state.contactPhoneOffice);
        formData.append('contactPhoneCell', this.state.contactPhoneCell);
        formData.append('contactEmail', this.state.contactEmail);
        formData.append('tocAgreement', this.state.tocAgreement);
        formData.append('storeName', this.state.storeName);
        formData.append('companyType', this.state.companyType);
        formData.append('owner', this.state.owner);

        if(this.state.image_file) {
            formData.append('image', this.state.image_file);
        }

        Api.putFile('/tenants',{
            method: 'POST',
            body: formData
        }).then(resp => {

        // Api.post('/tenants', params).then(resp => {
            this.setState({
                    loading: false,
                }
            );
            this.showMessage(true, 'Tenant added');
            history.push('/success');

        }).catch(err => {

            let errors = [];
            if(err.errors) {
                errors = err.errors;
                _.forEach(errors, function(v,k){
                    v = v[0];
                });
            }

            this.setState({
                    errors: errors,
                    loading: false
                }
            );

            this.showMessage(false, err.message);

        });

    };

    handleChange (e, prop){

        this.setState({

            [prop]: e.target.value

        })

    };

    handleChecked = name => e => {

        this.setState({

            [name]: e.target.checked ? 1 : 0,

        }, () => {

        });

    };

    render() {

        let lang = {};
        if(this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        }else {
            lang = language.en;
        }
        const text = lang;

        return (
            <main className='login'>
                <section>
                    <div className='container position-relative'>
                        <div className='row align-items-center m-0 row-login'>
                            <div className='col-md-6 col-lg-7 px-lg-7 text-center text-md-left'>
                                <img src={Logo} alt='logo' className='img-logo' />
                            </div>
                            <div className='col-md-6 col-lg-5 px-lg-5 text-center'>
                                <p>{text.register2_step}</p>
                                <h1>{text.register2_heading}</h1>
                                <p> </p>
                                <form name='register1' id='register1' noValidate>
                                    <div className='row'>
                                        <div className='col-3'>
                                            <div className='form-group'>
                                                <TextField
                                                    select
                                                    id='companyType'
                                                    name='companyType'
                                                    label='Tipe'
                                                    onChange={(e) => this.handleChange(e, 'companyType')}
                                                    value={this.state.companyType}
                                                    fullWidth
                                                >
                                                      <MenuItem value='PT'>PT</MenuItem>
                                                      <MenuItem value='CV'>CV</MenuItem>
                                                      <MenuItem value='UD'>UD</MenuItem>
                                                      <MenuItem value='Perorangan'>Perorangan</MenuItem>
                                                </TextField>
                                                {this.validator.message('companyType', this.state.companyType, 'required')}
                                                <div className='text-danger'>{this.state.errors.companyType}</div>
                                            </div>
                                        </div>
                                        <div className='col-9'>
                                            <div className='form-group'>
                                                <TextField
                                                    type='text'
                                                    id='companyName'
                                                    name='companyName'
                                                    label={text.label_company}
                                                    placeholder={text.label_company}
                                                    onChange={(e) => this.handleChange(e, 'companyName')}
                                                    value={this.state.companyName}
                                                    fullWidth
                                                />
                                                {this.validator.message('companyName', this.state.companyName, 'required')}
                                                <div className='text-left text-alert'>{this.state.errors.companyName}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='form-group position-relative'>
                                        <Tooltip
                                            arrow
                                            title={text.label_tooltip}
                                            placement='top'>
                                            <i className='fas fa-question-circle tooltip-icon'> </i>
                                        </Tooltip>
                                        <TextField
                                            type='text'
                                            id='imageFiles'
                                            name='imageFiles'
                                            label={text.label_upload_company}
                                            value={this.state.image_name}
                                            fullWidth
                                            autoComplete='off'
                                        />
                                        <label
                                            htmlFor="image"
                                            id="upload-image"
                                        >{text.label_browse}</label>
                                        <TextField
                                            accept='.jpg,.jpeg,.png'
                                            type='file'
                                            id='image'
                                            name='image'
                                            className='avatar d-none'
                                            onChange={this.handleUpload}
                                            fullWidth
                                        />
                                        {this.validator.message('image', this.state.image, 'required')}
                                        <div className='text-danger'>{this.state.errors.image}</div>

                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='primaryAddress'
                                            name='primaryAddress'
                                            label={text.label_address}
                                            placeholder={text.label_address}
                                            onChange={(e) => this.handleChange(e, 'primaryAddress')}
                                            value={this.state.primaryAddress}
                                            fullWidth
                                        />
                                        {this.validator.message('primaryAddress', this.state.primaryAddress, 'required')}
                                        <div className='text-left text-alert'>{this.state.errors.primaryAddress}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='primaryCity'
                                            name='primaryCity'
                                            label={text.label_city}
                                            placeholder={text.label_city}
                                            onChange={(e) => this.handleChange(e, 'primaryCity')}
                                            value={this.state.primaryCity}
                                            fullWidth
                                        />
                                        {this.validator.message('primaryCity', this.state.primaryCity, 'required')}
                                        <div className='text-left text-alert'>{this.state.errors.primaryCity}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='primaryState'
                                            name='primaryState'
                                            label={text.label_state}
                                            placeholder={text.label_state}
                                            onChange={(e) => this.handleChange(e, 'primaryState')}
                                            value={this.state.primaryState}
                                            fullWidth
                                        />
                                        {this.validator.message('primaryState', this.state.primaryState, 'required')}
                                        <div className='text-left text-alert'>{this.state.errors.primaryState}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='primaryPostalCode'
                                            name='primaryPostalCode'
                                            label={text.label_zipcode}
                                            placeholder={text.label_zipcode}
                                            onChange={(e) => this.handleChange(e, 'primaryPostalCode')}
                                            value={this.state.primaryPostalCode}
                                            fullWidth
                                        />
                                        {this.validator.message('primaryPostalCode', this.state.primaryPostalCode, 'required')}
                                        <div className='text-left text-alert'>{this.state.errors.primaryPostalCode}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='contactPhoneOffice'
                                            name='contactPhoneOffice'
                                            label={text.label_phone}
                                            placeholder={text.label_phone}
                                            onChange={(e) => this.handleChange(e, 'contactPhoneOffice')}
                                            value={this.state.contactPhoneOffice}
                                            fullWidth
                                        />
                                        {this.validator.message('contactPhoneOffice', this.state.contactPhoneOffice, 'numeric|required')}
                                        <div className='text-left text-alert'>{this.state.errors.contactPhoneOffice}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='storeName'
                                            name='storeName'
                                            label='Nama Toko'
                                            placeholder='Nama Toko'
                                            onChange={(e) => this.handleChange(e, 'storeName')}
                                            value={this.state.storeName}
                                            fullWidth
                                        />
                                        <div className='text-left text-alert'>{this.state.errors.storeName}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='owner'
                                            name='owner'
                                            label='Nama Pemilik Toko'
                                            placeholder='Nama Pemilik Toko'
                                            onChange={(e) => this.handleChange(e, 'owner')}
                                            value={this.state.owner}
                                            fullWidth
                                        />
                                        <div className='text-left text-alert'>{this.state.errors.owner}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='contactTitle'
                                            name='contactTitle'
                                            label={text.label_type_contact}
                                            placeholder={text.label_type_contact}
                                            onChange={(e) => this.handleChange(e, 'contactTitle')}
                                            value={this.state.contactTitle}
                                            fullWidth
                                        />
                                        {this.validator.message('contactTitle', this.state.contactTitle, 'required')}
                                        <div className='text-left text-alert'>{this.state.errors.contactTitle}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='contactName'
                                            name='contactName'
                                            label={text.label_name_contact}
                                            placeholder={text.label_name_contact}
                                            onChange={(e) => this.handleChange(e, 'contactName')}
                                            value={this.state.contactName}
                                            fullWidth
                                        />
                                        {this.validator.message('contactName', this.state.contactName, 'required')}
                                        <div className='text-left text-alert'>{this.state.errors.contactName}</div>
                                    </div>

                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='contactPhoneCell'
                                            name='contactPhoneCell'
                                            label={text.label_handphone}
                                            placeholder={text.label_handphone}
                                            onChange={(e) => this.handleChange(e, 'contactPhoneCell')}
                                            value={this.state.contactPhoneCell}
                                            fullWidth
                                        />
                                        {this.validator.message('contactPhoneCell', this.state.contactPhoneCell, 'numeric|required')}
                                        <div className='text-left text-alert'>{this.state.errors.contactPhoneCell}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='contactEmail'
                                            name='contactEmail'
                                            label={text.label_email}
                                            placeholder={text.label_email}
                                            onChange={(e) => this.handleChange(e, 'contactEmail')}
                                            value={this.state.contactEmail}
                                            fullWidth
                                        />
                                        {this.validator.message('contactEmail', this.state.contactEmail, 'email|required')}
                                        <div className='text-left text-alert'>{this.state.errors.contactEmail}</div>
                                    </div>

                                    <div className='form-group'>
                                        <FormControl component='fieldset' className='col '>
                                            <FormGroup>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            color='primary'
                                                            checked={this.state.tocAgreement}
                                                            onChange={this.handleChecked('tocAgreement')}
                                                            value='tocAgreement' />}
                                                    className='label-tnc'
                                                    label={text.register2_tnc}
                                                />
                                                {this.validator.message('tocAgreement', this.state.tocAgreement, 'required')}
                                                <div className='text-left text-alert'>{this.state.errors.tocAgreement}</div>
                                            </FormGroup>
                                        </FormControl>
                                    </div>
                                    <div className='row align-items-center'>
                                        <div className='col-6 text-left'>
{/*
                                            <Link to='/success' className='text-blue'>Lewati</Link>
*/}
                                        </div>
                                        <div className='col-6'>
                                            <Button
                                                variant='contained'
                                                onClick={this.handleSubmit}
                                                color='primary'
                                                disabled={this.state.loading}
                                                className='full'
                                            >
                                                {text.button_register} { this.state.loading && <i className='fa fa-spinner fa-spin'> </i> }
                                            </Button>
                                        </div>
                                    </div>
                                    <div className='text-left text-alert mb-2'> {this.state.errors.message} </div>
                                </form>
                            </div>
                            <div className='col-12 mt-auto footer-float position-lg-absolute'>
                                <div className='row justify-content-end'>
                                    <div className='col-md-6 col-lg-5'>
                                        <footer>
                                            <p className='text-center d-none d-md-block'>Copyright © 2020 Fresh Factory. All rights reserved</p>
                                        </footer>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
                <footer>
                    <p className='text-center d-md-none'><Copyright /></p>
                </footer>
                <ToastContainer autoClose={false} />
            </main>
        )
    }
}

const mapStateToProps = (state) => {

    return {

        profile_state: state.profile_state,

        toggle_set_lang: state.toggle_set_lang,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(Company);